<template>
  <div id="app" @click="isTimeOut">
    <Modal v-show='isModalShow' @hidemodal='hidemodal'></Modal>
    <router-view>
       
    </router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  components:{
    Modal: () => import('./components/Modal.vue')
  },
  data(){
    return{
      isModalShow: false,
      lastTime: null, //last time click
      currentTime: null, //current time click
      timeOut: 100 * 60 * 1000 //set the timeout to 10 mins
    }
  },
  watch:{
    "$store.state.isModalShow":{
      deep:true,
      handler:function(newVal,oldVal){
        this.isModalShow = newVal
        this.$store.dispatch('logout')
      }
    }
  },
  computed:{
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
  },
  created(){
    this.lastTime = new Date().getTime();
  },
  methods:{
    isTimeOut () {
      this.currentTime = new Date().getTime() //record the time of this click
      if (this.currentTime - this.lastTime > this.timeOut) { //check the time slot 
        if (this.isLoggedIn) { 
          this.isModalShow = true;
          this.$store.dispatch('logout')
        
        } else {
          this.lastTime = new Date().getTime()
        }
      } else {
        this.lastTime = new Date().getTime() //if click within 10 mins, replace last time to this time
      }
    },
    hidemodal(){
      this.isModalShow = false;
      this.$router.push('/login')
    }
  }
  

  
}

</script>
<style scoped>

@import "../static/lib/fontawesome-free/css/all.min.css";
@import "../static/lib/ionicons/css/ionicons.min.css";
@import "../static/lib/typicons.font/typicons.css";
@import "../static/lib/morris.js/morris.css";
@import "../static/lib/flag-icon-css/css/flag-icon.min.css";
@import "../static/lib/jqvmap/jqvmap.min.css";
@import "../static/css/azia.css";
</style>
